import axios from "axios";
import { supabase } from "./supabase";
import { isTermsRequiredError, TERMS_REQUIRED_EVENT } from "./termsGate";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  withCredentials: true,
  headers: { "Content-Type": "application/json" },
});

// Interceptor to add the Supabase JWT to every request
api.interceptors.request.use(async (config) => {
  const { data: { session } } = await supabase.auth.getSession();
  if (session) {
    config.headers.Authorization = `Bearer ${session.access_token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

// The API gates every route until the account agrees to the terms; tell the
// auth context so it can show the one-time step (covers cached profiles too).
api.interceptors.response.use((response) => response, (error) => {
  if (isTermsRequiredError(error) && typeof window !== "undefined") {
    window.dispatchEvent(new Event(TERMS_REQUIRED_EVENT));
  }
  return Promise.reject(error);
});

// Format FastAPI error detail (can be string or array of objects)
export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail.map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e))).filter(Boolean).join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
